import isolate from "@cycle/isolate"

import * as R from "ramda"

import { STATE_KEY, INPUT_CHECK } from "../../../../constant"

import {
  createCheckInfo,
} from "../../../common"
import { InputCheck, ModificationType, WorkForm} from "../../../../interface"

import { view } from "./view"
import { Confirm, Form } from ".."

const workCheck = (input: WorkForm, checkInfo: InputCheck) => {
  const require = input.workPlace || input.wAddr ||
    input.wTel ||
    input.wFax ||
    input.wZip1 ||
    input.wZip2 ||
    input.wPref
  const { varName, message, re } = checkInfo
  const value = R.propOr("", varName, input)
  let check = R.isEmpty(value) && !require
  if (!check) {
    check = typeof re === "function" ? re(input) : re.test(value as string)
  }
  return { [varName]: { check, message, require } }
}
const homeCheck = (input: WorkForm, checkInfo: InputCheck) => {
  const require = input.zip1 || input.zip2 ||
    input.pref ||
    input.addr1 ||
    input.addr2 ||
    input.tel
  const { varName, message, re } = checkInfo
  const value = R.propOr("", varName, input)
  let check = R.isEmpty(value) && !require
  if (!check) {
    check = typeof re === "function" ? re(input) : re.test(value as string)
  }
  return { [varName]: { check, message, require } }
}

const INPUT_CHECKS: InputCheck[] = [
  createCheckInfo("workPlace", /^.+$/, "勤務先名を入力してください。", false, workCheck),
  createCheckInfo("wPref", /^.+$/, "都道府県を選択してください。", false, workCheck),
  createCheckInfo("wAddr", /^.+$/, "住所を入力してください。", false, workCheck),
  createCheckInfo("wZip1", /^\d{3}$/, "半角数字7桁で入力して下さい。", false, workCheck),
  createCheckInfo("wZip2", /^\d{4}$/, "半角数字7桁で入力して下さい。", false, workCheck),
  R.mergeLeft({ varName: "wTel", delegate: workCheck }, INPUT_CHECK["tel"]),
  R.mergeLeft({ varName: "wFax" }, INPUT_CHECK["fax"]),
  createCheckInfo("zip1", /^\d{3}$/, "半角数字7桁で入力して下さい。", false, homeCheck),
  createCheckInfo("zip2", /^\d{4}$/, "半角数字7桁で入力して下さい。", false, homeCheck),
  createCheckInfo("pref", /^.+$/, "都道府県を選択してください。", false, homeCheck),
  createCheckInfo("addr1", /^.+$/, "住所を入力してください。", false, homeCheck),
  R.mergeLeft({ delegate: homeCheck }, INPUT_CHECK["tel"]),
  INPUT_CHECK["fax"],
  INPUT_CHECK["mobile"],
  createCheckInfo("addrSelect", /^.+$/, "送付先を選択してください。", true),
]

export default isolate(Form("work", STATE_KEY.WorkForm, view, INPUT_CHECKS))

const getReqParam = ([user, form] : [any, any]) => {
  const type = ModificationType.Work
  const memberId = R.prop("id", user)
  return {
    type, memberId, body: form,
  }
}

export const WorkConfirm = isolate(Confirm(STATE_KEY.WorkForm, view, getReqParam))
